/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIChingConsultationDto } from '../../models/platform-api-result-of-i-ching-consultation-dto';
import { PlatformUpdateIChingConsultation } from '../../models/platform-update-i-ching-consultation';

export interface PostIchingConsultationsActionUpdate$Params {
      body: PlatformUpdateIChingConsultation
}

export function postIchingConsultationsActionUpdate(http: HttpClient, rootUrl: string, params: PostIchingConsultationsActionUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, postIchingConsultationsActionUpdate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>;
    })
  );
}

postIchingConsultationsActionUpdate.PATH = '/api/iching/consultations/action/update';
